import { toast } from "react-toastify";
import { getListDcmAdvertisersData, getListDcmCampaignsData, getListProfilesData, postDcmAuth, postPublish, postRefreshDcmAdvertisers, postRefreshDcmCampaigns, postSaveDcmProfile } from "../../../helpers/backend_helper";
import { toggleSelectDcmProfileModal } from "../../modals/reducer";
import { setDcmAdvertisers, setDcmAuth, setDcmCampaigns, setDcmProfileId, setDcmProfiles, setProfileAsked, setSelectedCreativesPublish } from "../reducer";
import { updateCreativePublishStatusAfterPublish } from "../thunk";

export const createGoogleAuth = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const clientPath = getState().MenuData.clientPath;
    const res = await postDcmAuth({ clientId: clientPath, redirect: window.location.href + '?type=dcm' });
    if (res?.status === 'ok') {
      if (typeof res.data !== 'object' && res.data !== null) {
        window.location.href = res.data;
      } else {
        if (res.data.hasOwnProperty('profileId') && res.data?.profileId !== null) {
          // profile connected
          dispatch(setProfileAsked(true));
          dispatch(setDcmProfileId(res.data.profileId));
          return true;
        } else {
          // toggle profile selector
          // await dispatch(getDcmProfiles());
          // dispatch(toggleSelectDcmProfileModal());
          return false;
        }
      }
    } else {
      toast.error(language[response?.code], {autoClose: 3000});
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getDcmProfiles = () => async (dispatch, getState) => {
  try {
    const clientPath = getState().MenuData.clientPath;
    const res = await getListProfilesData({ clientId: clientPath });
    // console.log(res);
    if (res.status === 'ok') {
      dispatch(setDcmProfiles(res.data.items));
      return res.data.items;
    } else {
      // throw error
    }
  } catch (error) {
    // console.log(error);
  }
};

export const saveDcmProfile = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const clientPath = getState().MenuData.clientPath;
    const dcmProfileId = getState().Publish.dcmProfileId;
    const res = await postSaveDcmProfile({ clientId: clientPath, profileId: dcmProfileId });
    // console.log(res);
    if (res.status === 'ok') {
      dispatch(toggleSelectDcmProfileModal());
      await dispatch(createGoogleAuth());
    } else {
      // error
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
  }
}

export const getDcmAdvertisers = () => async (dispatch, getState) => {
  try {
    const clientPath = getState().MenuData.clientPath;
    const profileId = getState().Publish.dcmProfileId;
    const res = await getListDcmAdvertisersData({ clientId: clientPath, profileId: profileId });
    // console.log(res);
    if (res.status === 'ok') {
      dispatch(setDcmAdvertisers(res.data.advertisers.advertisers));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const refreshDcmAdvertisers = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const clientPath = getState().MenuData.clientPath;
    const profileId = getState().Publish.dcmProfileId;
    const res = await postRefreshDcmAdvertisers({ clientId: clientPath, profileId: profileId });
    if (res.status === 'ok') {
      dispatch(setDcmAdvertisers(res.data.advertisers.advertisers));
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
  }
}

export const getDcmCampaigns = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const clientPath = getState().MenuData.clientPath;
    const { dcmProfileId, dcmAdvertiserId } = getState().Publish;
    const res = await getListDcmCampaignsData({
      clientId: clientPath,
      profileId: dcmProfileId,
      advertiserId: dcmAdvertiserId
    });
    // console.log(res);
    if (res.status === 'ok') {
      dispatch(setDcmCampaigns(res.data.campaigns.campaigns));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], {autoClose: 3000});
    // console.log(error);
  }
};

export const refreshDcmCampaigns = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const clientPath = getState().MenuData.clientPath;
    const { dcmProfileId, dcmAdvertiserId } = getState().Publish;
    const res = await postRefreshDcmCampaigns({
      clientId: clientPath,
      profileId: dcmProfileId,
      advertiserId: dcmAdvertiserId
    });
    // console.log(res);
    if (res.status === 'ok') {
      dispatch(setDcmCampaigns(res.data.campaings.campaigns));
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
  }
}

export const publishDcm = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { client } = getState().MenuData;
    const { currentCampaign } = getState().Campaign;
    const { selectedCreativesPublish, selectedPublishType, selectedPublishTagId, dcmProfileId, dcmAdvertiserId, dcmCampaignId, dcmPublishType, dcmName, dcmPoliteLoad } = getState().Publish;
    let templateType = selectedCreativesPublish[0].hasOwnProperty('figma') ? 'figma' : '';
    const creativeIds = selectedCreativesPublish.map(item => item._id); 
    const res = await postPublish({
      // companyId: client._id,
      creativeIds: creativeIds,
      campaignId: currentCampaign._id,
      publishType: 'dcm',
      // profileId: dcmProfileId,
      dcmAdvertiserId: dcmAdvertiserId,
      dcmCampaignId: dcmCampaignId,
      name: dcmName,
      politeLoad: dcmPoliteLoad,
      publishTagId: selectedPublishTagId,
      templateType: templateType
      // type: dcmPublishType
    });
    dispatch(setSelectedCreativesPublish([]));
    if (res.status === 'ok') {
      // reset state
      dispatch(updateCreativePublishStatusAfterPublish(creativeIds));
      toast.success(language[res.code], { autoClose: 3000 });
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
  }
}